import { I18n, Translate } from 'react-i18nify';
import us from './locales/us.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import getTranslationsForMomentjs from './locales/momentjs';
import moment from 'moment';
import * as momenttz from 'moment-timezone';

const translationsAllLanguages = {
  us,
  es,
  pt
};
export const syncTranslation = (language) => {
  I18n.setHandleMissingTranslation((key, replacement) => {
    if (
      replacement &&
      (typeof replacement === 'string' || replacement instanceof String)
    ) {
      global.console.warn(
        `Missing translation: ${key}. Replaced with ${replacement}`
      );
      return replacement;
    }

    global.console.warn(`Missing translation: ${key}.`);
    return `**${key}**`;
  });
  I18n.setTranslations(translationsAllLanguages);
  I18n.setLocale(language);
  // A lang that disagrees with the rendered text makes Chrome offer to translate the page.
  document.documentElement.lang = language === 'us' ? 'en' : language;

  moment.defineLocale(language, getTranslationsForMomentjs(language));
  moment.updateLocale(language, getTranslationsForMomentjs(language));
  moment.locale(language, getTranslationsForMomentjs(language));

  momenttz.defineLocale(language, getTranslationsForMomentjs(language));
  momenttz.updateLocale(language, getTranslationsForMomentjs(language));
  momenttz.locale(language, getTranslationsForMomentjs(language));
};

export const translate = (key, replacement, dictionary) => {
  if (dictionary) {
    return dictionary[I18n._locale]?.[key] || replacement || `**${key ?? ''}**`;
  }
  if (!key) {
    return '';
  }
  return I18n.t(key.replaceAll(' ', '_').replaceAll('.', '-'), replacement);
};

export { I18n, Translate };
